export default __webpack_public_path__ + "static/media/Group 706.16b4dede.png";